<div class="flex min-h-dvh flex-col bg-white text-slate-900">
  <header class="border-b border-slate-200">
    <div class="mx-auto flex w-full max-w-md items-center gap-4 px-4 py-4">
      <img
        src="logo-dark.png"
        alt="TITAN Containers"
        width="706"
        height="224"
        class="h-9 w-auto"
      />
      <select
        class="ml-auto rounded-lg border border-slate-300 px-2 py-1 text-sm text-slate-700"
        [attr.aria-label]="'app.language' | translate"
        [value]="currentLanguage()"
        (change)="changeLanguage($any($event.target).value)"
      >
        @for (language of languages; track language.code) {
          <option [value]="language.code">{{ language.label }}</option>
        }
      </select>
    </div>
  </header>

  <main class="flex-1">
    <router-outlet />
  </main>

  <footer class="mx-auto w-full max-w-md px-4 py-6 text-center text-xs text-slate-500">
    &copy; {{ year }} TITAN Containers
  </footer>
</div>
